import * as yup from 'yup';
import moment from 'moment';

// Constants

import { NAMES_VALIDATION_REGEX } from '../../../../config/constants';

export const validationSchema = [
  yup.object().shape({
    pep: yup.object().shape({
      pregunta1: yup.object().shape({
        nombreCargo: yup.string().required('Este campo es requerido'),
        nombreEnteAdscrito: yup.string().when("nombreCargo", {
          is: (val) => val !== '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
        pais: yup.string().when("nombreCargo", {
          is: (val) => val !== '0',
          then: yup.string().required('Este campo es requerido'),
          otherwise: yup.string(),
        }),
      }),
      hasAssociate: yup.string().required('Este campo es requerido'),
      pregunta2: yup.array().when('hasAssociate', {
        is: (val) => val === 'si',
        then: yup.array().of(
          yup.object().shape({
            respuesta: yup.string().required('Este campo es requerido'),
            tipoDeRelacion: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            nombrePersona: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            documentoIdentidad: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            fechaNacimiento: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            genero: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            lugarNacimiento: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            nacionalidad: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            otraNacionalidad: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string(),
              otherwise: yup.string(),
            }),
            profesion: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            direccionFiscal: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            telefono: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido').length(10, 'Digite el teléfono completo'),
              otherwise: yup.string(),
            }),
            nombreEnteAdscrito: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            nombreCargo: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
            pais: yup.string().when("respuesta", {
              is: (val) => val === 'si',
              then: yup.string().required('Este campo es requerido'),
              otherwise: yup.string(),
            }),
          })),
      }),
    }),
    fatca: yup.object().shape({
      tieneRelacion: yup.string().required('Este campo es requerido'),
      numitin: yup.string().min(8, 'TIN de al menos 8 caractéres'),
    }),
  }),
  yup.object().shape({
    hasBankReference: yup.string().required('Este campo es requerido'),
    bankReference: yup.object().when('hasBankReference', {
      is: (val) => val === 'si',
      then: yup.object().when("cliente.tipoCliente", {
        is: (val) => ['1', '2', '6'].includes(val),
        then: yup.object().shape({
          tipoBanco: yup.string().required('Este campo es requerido'),
          fechaConstancia: yup.string().required('Este campo es requerido').test("fechaConstanciaTest", "Fecha de constancia no puede ser mayor de 30 dias.", function (value) {
            const currentDate = moment();
            const constancyDate = moment(value);
            const dateDifference = currentDate.diff(constancyDate, 'days');

            if (dateDifference > 30) {
              return false;
            } else {
              return true;
            }
          }),
          banco: yup.object({
            codigo: yup.string().required('Este campo es requerido'),
            descripcion: yup.string().required('Este campo es requerido'),
          }),
          tipoCuenta: yup.string().required('Este campo es requerido'),
          numeroCuenta: yup.string().when("tipoBanco", {
            is: (val) => val === 'nacional',
            then: yup
              .string()
              .required('Este campo es requerido')
              .length(20, 'Por favor digite completo el número de cuenta')
              .test(
                "numeroCuentaTest",
                "El número de cuenta debe empezar con 0",
                function (value) {
                  return value?.charAt(0) === '0';
                }
              ),
            otherwise: yup
              .string()
              .required('Este campo es requerido')
              .matches(
                /^[a-zA-Z0-9]+$/,
                'Solo se permiten letras y números, sin espacios ni símbolos'
              ),
          }),
          fechaApertura: yup.string().required('Este campo es requerido'),
          numeroCifras: yup
            .number()
            .required('Este campo es requerido')
            .typeError('Favor ingresar un número')
            .min(1, 'Debe ser un número entre 1 y 9')
            .max(9, 'Debe ser un número entre 1 y 9'),
          tipoCifras: yup.object({
            codigo: yup.string().required('Este campo es requerido'),
            descripcion: yup.string().required('Este campo es requerido'),
          }),
          calificacion: yup.object({
            codigo: yup.string().required('Este campo es requerido'),
            descripcion: yup.string().required('Este campo es requerido'),
          }),
          observacion: yup.string(),
        }),
      }),
    }),
  }),
  yup.object().shape({
    declaration: yup.string().when(["hasBankReference", "cliente.tipoCliente"], {
      is: (hasBankReference, tipoCliente) => (hasBankReference === 'no' && ['1', '2', '6'].includes(tipoCliente)),
      then: yup.string().required('Este campo es requerido'),
      otherwise: yup.string(),
    }),
  }),
  yup.object().shape({
    personalReferences: yup.array().min(1, 'Añada al menos una referencia').of(
      yup.object({
        searchedOnList: yup.boolean().required('').test("searchedOnListTest", "", function (value) {
          return value === true;
        }),
        isOnList: yup.boolean().required('').test("isOnListTest", "", function (value) {
          return value === false;
        }),
        tipoDocumento: yup.string().required('Este campo es requerido'),
        cedulaReferencia: yup.string().when("tipoDocumento", {
          is: (val) => val !== 'P' && val !== undefined && val !== '',
          then: yup.string().required('Este campo es requerido').test("cedulaTest", "Número de identificación no puede iniciar con 0.", function (value) {
            return value?.charAt(0) !== '0';
          }),
          otherwise: yup.string().required('Este campo es requerido').test('pasaporteTest', 'Pasaporte de al menos 5 caracteres', val => val?.length >= 5),
        }),
        nombre: yup.string().required('Este campo es requerido').test("nombreTest", "Nombre sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        primerApellido: yup.string().required('Este campo es requerido').test("primerApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        segundoApellido: yup.string().test("segundoApellidoTest", "Apellido sin acentos o caracteres especiales", function (value) {
          return NAMES_VALIDATION_REGEX?.test(value);
        }),
        codParentesco: yup.string().required('Este campo es requerido'),
        telefonoDomicilio: yup
          .string()
          .test(
            'telefonoDomicilio-validation',
            'Digite el teléfono completo',
            function (value) {
              if (!value) return true;
              return value.length === 10;
            }
          )
          .test(
            'at-least-one-phone',
            'Debe ingresar al menos un teléfono o celular',
            function (value) {
              const { telefonoOtro } = this.parent;
              return !!(value || telefonoOtro);
            }
          ),
        telefonoOtro: yup
          .string()
          .test(
            'telefonoOtro-validation',
            'Digite el teléfono completo',
            function (value) {
              if (!value) return true;
              return value.length === 10;
            }
          )
          .test(
            'at-least-one-phone',
            'Debe ingresar al menos un teléfono o celular',
            function (value) {
              const { telefonoDomicilio } = this.parent;
              return !!(value || telefonoDomicilio);
            }
          ),
      }),
    ),
  })
];